/**
 * JS for ACF: Flexible Content > Layouts > Témoignages
 */

const sliderTestimonials = () => {
  const sectionsSliderTestimonials = document.querySelectorAll(
    ".layout-testimonials"
  );

  if (sectionsSliderTestimonials.length > 0) {
    sectionsSliderTestimonials.forEach((section) => {
      const containerSliderTestimonials = section.querySelector(".layout-testimonials__container");
      const sliderTestimonials = containerSliderTestimonials.querySelector(".slider-testimonials");

      const sliderTestimonialsSwiper = new Swiper(sliderTestimonials, {
        slidesPerView: 1,
        navigation: {
          nextEl: containerSliderTestimonials.querySelector(".swiper-button-next"),
          prevEl: containerSliderTestimonials.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: containerSliderTestimonials.querySelector(".swiper-pagination"),
          clickable: true,
        }
      });
    });
  }
};

sliderTestimonials();
